import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ConfigModule, I18nModule, provideConfig } from '@spartacus/core'
import { AutoFillNoDialogComponent } from './auto-fill-no-dialog/auto-fill-no-dialog.component'
import { FormsModule } from '@angular/forms'
import { environment } from '../../../../environments/environment'
import { DIALOG_TYPE } from '@spartacus/storefront'
import { WarningDialogComponent } from '../warning-dialog/warning-dialog/warning-dialog.component'
import { VS_LAUNCH_CALLER } from '../../../features/config/dialog.config'

@NgModule({
  declarations: [AutoFillNoDialogComponent, WarningDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['sharedComponents'],
        },
      },
    }),
  ],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.WARNING_DIALOG]: {
          inlineRoot: true,
          component: WarningDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
  exports: [AutoFillNoDialogComponent],
})
export class ComplianceQuestionsDialogModule {}
